var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main-panel",
    [
      _c("template", { slot: "main-panel-content" }, [
        _c("div", { staticClass: "p-4 width-100" }, [
          _c("h2", { staticClass: "mb-4" }, [_vm._v("\n        Home\n      ")]),
          _vm._v(" "),
          _c("h5", [
            _vm._v(
              "Please start by selecting which site you would like to edit."
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "mt-4 d-flex align-items-center justify-content-start"
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-card",
                  on: { click: _vm.handleGlobalButtonClick }
                },
                [
                  _c("i", { staticClass: "fas fa-globe fa-3x" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-3 app-font" }, [
                    _vm._v("\n            Global Care\n          ")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ml-4 app-card",
                  on: { click: _vm.handlePaymentsButtonClick }
                },
                [
                  _c("i", { staticClass: "fas fa-credit-card fa-3x" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-3 app-font" }, [
                    _vm._v("\n            Payments\n          ")
                  ])
                ]
              )
            ]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }